// import React, { useContext } from 'react'
import InnerPageTalks from './innerPageTalks'
import TemplateMain from '../templateMain'
import { SLIDESHOWS } from '../../types'

export default function PageTalks () {
  return (
    <TemplateMain
      g_section='code'
      htmlTitle='Talks'
      linksTitle='Greg Sandell - Talks'
      innerPage={<InnerPageTalks />}
      g_sidebarKey='pageTalks'
      g_slideshowKey={SLIDESHOWS.logos}
    />
  )
}
